import { Link } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { LandingCallbackDialog } from "./LandingCallbackDialog";
import { LandingLicensesSheet } from "./LandingLicensesSheet";

const SUPPORT_EMAIL = "support@kriptodoc.ru";

export function LandingFooter() {
  return (
    <footer className="border-t border-slate-200 py-10 bg-white" data-testid="landing-footer-container">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-[#4E9BEE] to-[#2563EB] flex items-center justify-center">
            <Lock className="w-3.5 h-3.5 text-white" />
          </div>
          <span className="text-slate-900 font-semibold text-sm">КриптоДок</span>
          <span className="text-slate-400 text-xs hidden sm:inline">© {new Date().getFullYear()} Все права защищены</span>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-slate-500">
          <a href="#how-it-works" className="hover:text-slate-900">Как это работает</a>
          <a href="#trust" className="hover:text-slate-900">Безопасность</a>
          <Link to="/verify" className="hover:text-slate-900" data-testid="landing-footer-verify-link">
            Проверка подлинности
          </Link>
          <Link to="/about" className="hover:text-slate-900" data-testid="landing-footer-about-link">
            О компании
          </Link>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="hover:text-slate-900 flex items-center gap-1.5"
            data-testid="landing-footer-email-link"
          >
            <Mail className="w-3.5 h-3.5" />
            {SUPPORT_EMAIL}
          </a>
          <LandingCallbackDialog />
          <LandingLicensesSheet />
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 pt-6 border-t border-slate-100">
        <p className="text-[11px] leading-relaxed text-slate-400" data-testid="landing-footer-legal-note">
          Мы используем файлы cookie, чтобы сайт корректно работал и подстраивался под вас, а также
          для аналитики и других целей, указанных в нашей политике обработки персональных данных;
          на сайте могут применяться рекомендательные технологии. КриптоДок — отечественное
          программное обеспечение, зарегистрированное в реестре российских программ для ЭВМ и баз данных.
        </p>
      </div>
    </footer>
  );
}
